/*!

 =========================================================
 * RMS - Tracking - v1.2.3
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-black-dashboard-pro
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";

// router setup
import router from "./routes/router";
import i18n from "./i18n";
import "./registerServiceWorker";

// RMS
import store from "./store";
import axios from "axios";
//import 'bootstrap/dist/css/bootstrap.min.css'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

// RMS
Vue.prototype.$http = axios;

const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(axios);
Vue.use({
  install(Vue) {
    Vue.prototype.$apiNoAuthenticated = axios.create({
      baseURL: store.state.urlTracking
    });
  }
});
Vue.use({
  install(Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: store.state.urlTracking,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});
Vue.use({
  install(Vue) {
    Vue.prototype.$apiChecklist = axios.create({
      baseURL: store.state.urlChecklist,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});

Vue.use({
  install(Vue) {
    Vue.prototype.$apiScheduler = axios.create({
      baseURL: store.state.urlScheduler,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});

Vue.use({
  install(Vue) {
    Vue.prototype.$apiWorkflow = axios.create({
      baseURL: store.state.urlWorkflow,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});

Vue.use({
  install(Vue) {
    Vue.prototype.$apiVehicle = axios.create({
      baseURL: store.state.urlVehicle,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});

Vue.use({
  install(Vue) {
    Vue.prototype.$apiDynamicSearches = axios.create({
      baseURL: store.state.urlDynamicSearches,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.token
      }
    });
  }
});

store.dispatch("set_companyLayout");

// google maps
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps);

import { BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
Vue.use(BootstrapVueIcons);

import VueCompositionAPI from "@vue/composition-api";

Vue.use(VueCompositionAPI);

// // import Treeselect from "@riophae/vue-treeselect";
// import "@riophae/vue-treeselect/dist/vue-treeselect.css"
// // Vue.use(BootstrapVueIcons)

// register globally
import Multiselect from "vue-multiselect";

// register globally
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);
// Vue.component('vue-multiselect', window.VueMultiselect.default)

import uuid from "./mixins/uuid";
Vue.mixin(uuid);

import blobHelper from "./mixins/blobHelper";
Vue.mixin(blobHelper);

import datetime from "./mixins/datetime";
Vue.mixin(datetime);

import jsonHelper from "./mixins/jsonHelper";
Vue.mixin(jsonHelper);

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import moneyMaskDirective from "./directives/money-mask.js";
Vue.directive("money-mask", moneyMaskDirective);

import integerMaskDirective from "./directives/integer-mask.js";
Vue.directive("integer-mask", integerMaskDirective);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n
});
